export enum LIST_TYPE {
	ROW = 'row',
	COLUMN = 'column'
}
